import './Game.scss';
import store, { RootState } from '../store';
import { useAppSelector } from '../redux'
import { gameActions } from './gameSlice';
import SpritesheetAsset from '../Components/SpritesheetAsset';


function BottomBar() {

  const gameState = useAppSelector((state: RootState) => state.game);
  const balance = gameState.balance
  const bet = gameState.bet

  return (
    <div className="bottom-bar">
      <div className='bottom-bar-status'>
        <div> Bet: {bet} </div>
        <div>Balance: {balance}</div>
      </div>
    </div>
  );
}

export default BottomBar;
